import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { fetchSubstituteConductors, setPermissionaryConductors } from 'app/store/slices/line';

import CloseIcon from '@material-ui/icons/Close';
import IconButton from '@material-ui/core/IconButton';

import PageWrapper from '../../components/PageWrapper';
import DefaultTable from '../../components/DefaultTable';
import SaveBox from '../../components/SaveBox';

import { substituteConductorDrawerColumns } from '../../table-configs/columns-schemas';
import SimpleAlert from '../../components/SimpleAlert';
import { Button, FilledInput, FormControl, Grid, InputAdornment, InputLabel } from '@material-ui/core';
import Search from '@material-ui/icons/Search';
import { generatePath, useHistory } from 'react-router-dom';
import { URLS } from 'app/config/urls';

const FindConductor = ({ onClose, conductors }) => {
    const dispatch = useDispatch();
    const history = useHistory();

    const [loading, setLoading] = useState(false);
    const [selectedTempConductor, setSelectedTempConductor] = useState([]);
    const [alertMessage, setAlertMessage] = useState(null);

    const [page, setPage] = useState(0);
    const [pageSize, setPageSize] = useState(10);

    const [orderBy, setOrderBy] = useState('deNome');
    const [orderDirection, setOrderDirection] = useState('desc');

    const [rows, setRows] = useState([]);

    const selectedLine = useSelector((state) => state.line.selected);
    const substituteConductors = useSelector((state) => state.line.allSubstituteConductors);
    const permissionaryConductors = useSelector((state) => state.line.permissionaryConductors);

    const [filters, setFilters] = useState(() => {
        const { cdLinha } = selectedLine;
        return {
            campoOrdenacao: orderBy,
            direcaoOrdenacao: orderDirection,
            cdLinha,
        };
    });

    useEffect(() => {
        (() => {
            const tempConductors = substituteConductors?.content || [];
            setRows(
                tempConductors.map((conductor) => {
                    const temp = { ...conductor };
                    const found = conductors
                        .filter((c) => !c.boExcluido)
                        .find((c) => c.cdCondutorSubstituto === conductor.cdCondutorSubstituto);
                    if (found) {
                        temp.checked = true;
                        temp.lockCheckbox = true;
                    }
                    return temp;
                }),
            );
        })();
    }, [substituteConductors, conductors]);

    useEffect(() => {
        (async () => {
            setLoading(true);
            await dispatch(fetchSubstituteConductors({ page, size: pageSize, request: filters }));
            setLoading(false);
        })();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [dispatch, page, pageSize, filters]);

    const handleSelectConductor = ({ data }) => {
        setSelectedTempConductor(data);
    };

    const handleSaveSelected = () => {
        if (!selectedTempConductor || selectedTempConductor.length === 0) {
            setAlertMessage('Selecione um condutor substituto para adicionar ao permissionário.');
        } else {
            dispatch(setPermissionaryConductors([...permissionaryConductors, selectedTempConductor]));
            onClose();
        }
    };

    const handleChangePageSize = (e) => {
        setPageSize(parseInt(e.target.value));
    };

    const handleChangePage = (e, page) => {
        setPage(page);
    };

    const handleChangeOrder = (event, property) => {
        let tempDirection = orderDirection;
        if (property === orderBy) {
            tempDirection = orderDirection === 'desc' ? 'asc' : 'desc';
        }
        const temp = { ...filters };
        temp['campoOrdenacao'] = `${property}`;
        temp['direcaoOrdenacao'] = tempDirection;
        setOrderDirection(tempDirection);
        setOrderBy(property);
        setFilters(temp);
        setPage(0);
    };

    const handleBlurSearch = (event) => {
        const temp = { ...filters };
        temp['txtBusca'] = event.target.value;
        setFilters(temp);
        setPage(0);
    };

    const handleCreateSubstituteConductor = () => {
        const cdLinha = selectedLine.cdLinha;
        history.push(generatePath(URLS.LINES_MANAGE_CONDUCTORS_NEW, { cdLinha }));
    };

    return (
        <>
            <PageWrapper
                loading={loading}
                maxWidth="md"
                title="Adicionar condutor substituto"
                isPlain
                actionButton={
                    <IconButton onClick={onClose}>
                        <CloseIcon />
                    </IconButton>
                }>
                <Grid item xs={12} container spacing={2}>
                    <Grid item xs={4}>
                        <FormControl size="small" variant="filled" fullWidth>
                            <InputLabel>Buscar</InputLabel>
                            <FilledInput
                                id="outlined-adornment-weight"
                                defaultValue={''}
                                onBlur={handleBlurSearch}
                                onChange={() => {}}
                                endAdornment={
                                    <InputAdornment position="end">
                                        <Search />
                                    </InputAdornment>
                                }
                                aria-describedby="outlined-weight-helper-text"
                                inputProps={{
                                    'aria-label': 'weight',
                                }}
                            />
                        </FormControl>
                    </Grid>
                    <Grid item xs={6}></Grid>

                    <Grid item xs={2} alignItems="center">
                        <Button fullWidth variant="contained" color="primary" onClick={handleCreateSubstituteConductor}>
                            Novo
                        </Button>
                    </Grid>
                    <Grid item xs={12}>
                        <DefaultTable
                            loading={loading}
                            columns={substituteConductorDrawerColumns}
                            rows={rows}
                            entryProps={{
                                onChangeSelect: handleSelectConductor,
                                selectedId: selectedTempConductor?.cdCondutorSubstituto,
                            }}
                            paginationProps={{
                                rowsPerPageOptions: [5, 10, 25],
                                count: substituteConductors?.totalElements || 0,
                                rowsPerPage: pageSize,
                                page: page,
                                onPageChange: handleChangePage,
                                onRowsPerPageChange: handleChangePageSize,
                            }}
                            orderBy={orderBy}
                            order={orderDirection}
                            onRequestSort={handleChangeOrder}
                        />
                    </Grid>
                    <Grid item xs={12}>
                        <SaveBox
                            firstButtonLabel="Voltar"
                            middleButtonLabel="Adicionar"
                            onSave={handleSaveSelected}
                            onCancel={onClose}
                        />
                    </Grid>
                </Grid>
            </PageWrapper>
            <SimpleAlert open={!!alertMessage} onClose={() => setAlertMessage(null)}>
                {alertMessage}
            </SimpleAlert>
        </>
    );
};

export default FindConductor;
